import { useEffect } from 'react'

import useParticipantIntroOverlay from '../../hooks/useParticipantIntroOverlay'
import { useOverlayState } from '../../../firebase/hooks/useOverlays'

// eslint-disable-next-line react/prop-types
const ProducerOverlayControls = () => {
  const overlay = useOverlayState()
  const { removeParticipantIntroOverlay } = useParticipantIntroOverlay()

  /*
   * Start timeout time when the overlay changes and the selected type is "speaker"
   * and clear is every time the overlay changes
   */
  useEffect(() => {
    if (overlay?.type === 'speaker') {
      const timeout = setTimeout(removeParticipantIntroOverlay, 6000)

      return () => clearTimeout(timeout)
    }
    return undefined
  }, [overlay, removeParticipantIntroOverlay])

  return null
}

export default ProducerOverlayControls
